import './PropertyMap.scss';
import Component from './PropertyMap.js';
export default Component;
